import { AdoptsModalType } from './constants';
import BuyerModalLoadable from './modals/BuyerModalLoadable';
import SellerModalLoadable from '@wix/da-submit-shared/pkg/modals/seller/SellerModalLoadable';
import TransactionHistoryModalLoadable from './modals/TransactionHistoryModalLoadable';
import OrderOriginalDeviationModalLoadable from './modals/OrderOriginalDeviationModalLoadable';

export const adoptsModalRenderer = (
  modalType: string,
  requestClose: () => void,
  params?: any
) => {
  switch (modalType) {
    case AdoptsModalType.BUYER_MODAL:
      return (
        <BuyerModalLoadable
          onRequestClose={requestClose}
          deviation={params.deviation}
          initialScreen={params.initialScreen}
        />
      );
    case AdoptsModalType.SELLER_MODAL:
      return (
        <SellerModalLoadable
          onRequestClose={requestClose}
          deviations={params.deviation ? [params.deviation] : params.deviations}
          initialScreen={params.initialScreen}
          extraScreenProps={params.extraScreenProps}
        />
      );
    case AdoptsModalType.TRANSACTION_HISTORY_MODAL:
      return (
        <TransactionHistoryModalLoadable
          onRequestClose={requestClose}
          deviation={params.deviation}
        />
      );
    case AdoptsModalType.ORDER_ORIGINAL_DEVIATION_MODAL:
      return (
        <OrderOriginalDeviationModalLoadable
          deviation={params.deviation}
          onRequestClose={requestClose}
        />
      );
    default:
      return null;
  }
};
